import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PromoOutlineIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PromoOutlineIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.54004 6.59009H20.54C20.8162 6.59009 21.04 6.81395 21.04 7.09009V9.21791C18.9996 11.1747 18.9996 14.4742 21.04 16.431V18.5588C21.04 18.835 20.8162 19.0588 20.54 19.0588H4.54004C4.2639 19.0588 4.04004 18.835 4.04004 18.5588V16.431C6.08044 14.4742 6.08044 11.1747 4.04004 9.21791V7.09009C4.04004 6.81395 4.2639 6.59009 4.54004 6.59009ZM20.54 5.09009H4.54004C3.43547 5.09009 2.54004 5.98552 2.54004 7.09009V9.82458C2.54004 9.88708 2.56999 9.94579 2.62058 9.98247C4.5536 11.3841 4.5536 14.2648 2.62058 15.6665C2.56999 15.7031 2.54004 15.7618 2.54004 15.8243V18.5588C2.54004 19.6634 3.43547 20.5588 4.54004 20.5588H20.54C21.6446 20.5588 22.54 19.6634 22.54 18.5588V15.8243C22.54 15.7618 22.5101 15.7031 22.4595 15.6665C20.5265 14.2648 20.5265 11.3841 22.4595 9.98247C22.5101 9.94579 22.54 9.88708 22.54 9.82458V7.09009C22.54 5.98552 21.6446 5.09009 20.54 5.09009ZM16.2351 10.643C16.6322 10.2591 16.6429 9.62606 16.259 9.229C15.8751 8.83194 15.242 8.82125 14.845 9.20513L8.84497 15.0059C8.44791 15.3898 8.43722 16.0229 8.8211 16.4199C9.20498 16.817 9.83805 16.8277 10.2351 16.4438L16.2351 10.643ZM9.78955 11.4573C10.4799 11.4573 11.0396 10.8976 11.0396 10.2073C11.0396 9.51692 10.4799 8.95728 9.78955 8.95728C9.0992 8.95728 8.53955 9.51692 8.53955 10.2073C8.53955 10.8976 9.0992 11.4573 9.78955 11.4573ZM16.4902 15.5901C16.4902 16.2804 15.9306 16.8401 15.2402 16.8401C14.5499 16.8401 13.9902 16.2804 13.9902 15.5901C13.9902 14.8997 14.5499 14.3401 15.2402 14.3401C15.9306 14.3401 16.4902 14.8997 16.4902 15.5901Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PromoOutlineIcon;
